<template>
  <div class="mt-3">
    <strong>Total dynamic contents : {{ totalDynamicContentsDisplay }}</strong>
    <button
        type="button"
        tabindex="-1"
        v-show="totalDynamicContentsDisplay > 0"
        class="btn btn-outline-danger btn-sm ml-2"
        @click.prevent="deleteDynamicContents"
    >Delete
    </button>
  </div>
</template>

<script>
export default {
  props: {
    urlDelete: {
      required: true,
      type: String,
    },
    totalDynamicContentsDisplay: {
      required: true,
      type: Number,
    }
  },
  methods: {
    deleteDynamicContents: function () {
      axios.delete(this.urlDelete)
          .then(response => {
            console.log(response)
          })
          .then(() => {
            this.emitDeleteDynamicContents()
          })
          .catch(error => {
            alert(error)
          })
    },
    emitDeleteDynamicContents: function () {
      this.$emit('delete-dynamic-contents')
    }
  }
}
</script>

<style scoped>

</style>